var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/~/core-js/internals/engine-is-node.js
// module id = 1757
// module chunks = 118